// Barrel — server actions live in ./server/<domain>.ts modules.
// This file preserves the public `@/lib/actions` import surface so components
// don't change. Shared internals (types/helpers/consts) live in ./server/shared
// and ./server/notify and are intentionally NOT re-exported here.
//
// NOTE: do not add "use server" here — this barrel re-exports types too, which a
// "use server" file may not. Each domain module carries its own "use server".

export type { ActionResult } from "./server/shared";

export * from "./server/auth";
export * from "./server/users";
export * from "./server/prefs";
export * from "./server/dashboard-shortcuts";
export * from "./server/tasks";
export * from "./server/groups";
export * from "./server/boards";
export * from "./server/projects";
export * from "./server/clients";
export * from "./server/files";
export * from "@/features/notifications/server";
export * from "@/features/reports/server";
export * from "./server/trash";
